module.exports = __webpack_public_path__ + "static/media/karna_crypto.91c4f618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karna/karna_crypto.png
// module id = 392
// module chunks = 0